module.exports = __webpack_public_path__ + "img/Austria.55db38c6.png";